    <div cdkMenu class="menu-context">
        <button (click)="editEvent($event)" cdkMenuItem
            class="menu-context-item" data-action="editEvent">
            <mat-icon class="menu-icon" matPrefix>more_vert</mat-icon>
            {{ 'CONTEXT_MENU.VIEW' | translate }}..
        </button>
<!--         <button (click)="editStep($event)" cdkMenuItem
            class="menu-context-item" data-action="editStep">
            <mat-icon class="menu-icon" matPrefix>edit</mat-icon>
            {{ 'CONTEXT_MENU.EDIT' | translate }}..
        </button> -->
        <button (click)="deleteEvent($event)" cdkMenuItem
            class="menu-context-item" data-action="deleteEvent">
            <mat-icon class="menu-icon" matPrefix>delete</mat-icon>
            {{ 'CONTEXT_MENU.DELETE' | translate }}..
        </button>
    </div>